import { useEffect, useState } from "react";

const links = [
  { label: "瓜田热搜", href: "#hot" },
  { label: "分析方向", href: "#analysis" },
  { label: "深扒专栏", href: "#deep" },
  { label: "剧本拆解", href: "#playbook" },
  { label: "防晕指南", href: "#spot" },
  { label: "常见问答", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 border-b border-background-200/80 backdrop-blur" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[72px] max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          className="flex items-center gap-2 whitespace-nowrap"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-bubble-chart-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-bold text-foreground-950">
            吃瓜<span className="text-primary-500">透视局</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-primary-50 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#join"
            className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅简报
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 lg:hidden"
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#join"
            onClick={() => setOpen(false)}
            className="mt-2 block whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50 hover:bg-primary-600"
          >
            订阅简报
          </a>
        </div>
      )}
    </header>
  );
}